import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";
import router from 'router'
 
//创建实例
const service = axios.create({
  baseURL: "/", //请求地址
  timeout: 5000, //超时
});
 
//添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // 从localStorage获取Token
    const token = localStorage.getItem('token');
    // 如果Token存在，则添加到请求头
    if (token) {
        //Bearer 
      config.headers['token'] = `${token}`;
    }
    return config;
  },
  function (error) {
    // 处理请求错误
    console.log(error.request);
    const errorData = JSON.parse(error.request.response);
    if (errorData.message) {
      //判断是否具有message属性
      ElMessage({
        message: errorData.message,
        type: "error",
      });
    }
    //对请求错误做些什么
    return Promise.reject(errorData);
  }
);
 
//添加响应拦截器
service.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    // //对响应错误做些什么
    // const errorData = JSON.parse(error.request.response);
    // if (errorData.message) {
    //   //判断是否具有message属性
    //   ElMessage({
    //     message: errorData.message,
    //     type: "error",
    //   });
    // }
    const { response } = error;
    if (response && response.status === 401) {
      // 401错误处理逻辑
      const errorMsg = response.data?.message || '登录已过期，请重新登录';
      
      // 避免重复弹窗
      if (!window.isRefreshingToken) {
        window.isRefreshingToken = true;
        
        // 显示登录过期提示并跳转登录页
        ElMessageBox.alert(errorMsg, '登录已过期', {
          confirmButtonText: '登录',
          cancelButtonText: '返回',
          type: 'warning'
        }).then(() => {
          // 清除本地存储push的令牌
          localStorage.removeItem('token');
          // 跳转到登录页，并记录当前路径用于登录后返回
          router.push('/login');
        }).catch(() => {
          // 用户取消操作
        }).finally(() => {
          window.isRefreshingToken = false;
        });
      }
    } else {
      // 其他错误提示
      ElMessage.error(response?.data?.message || '请求失败');
    }
 
    return Promise.reject(errorData);
  }
);
 
//暴露service
export default service;